'use client';

import _defineProperty from "/codebuild/output/src2998/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src2998/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["transitionProps", "className", "innerProps", "onKeyDown", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import cx from 'clsx';
import { FocusTrap } from '../FocusTrap/FocusTrap.mjs';
import { Paper } from '../Paper/Paper.mjs';
import '../Transition/transitions.mjs';
import { Transition } from '../Transition/Transition.mjs';
import { useModalBaseContext } from './ModalBase.context.mjs';
import classes from './ModalBase.module.css.mjs';
var ModalBaseContent = forwardRef(function (_ref, ref) {
  var transitionProps = _ref.transitionProps,
    className = _ref.className,
    innerProps = _ref.innerProps,
    onKeyDown = _ref.onKeyDown,
    style = _ref.style,
    others = _objectWithoutProperties(_ref, _excluded);
  var ctx = useModalBaseContext();
  return /* @__PURE__ */jsx(Transition, _objectSpread(_objectSpread(_objectSpread({
    mounted: ctx.opened,
    transition: "pop"
  }, ctx.transitionProps), transitionProps), {}, {
    children: function children(transitionStyles) {
      return /* @__PURE__ */jsx("div", _objectSpread(_objectSpread({}, innerProps), {}, {
        className: cx(_defineProperty({}, classes.inner, !ctx.unstyled), innerProps.className),
        children: /* @__PURE__ */jsx(FocusTrap, {
          active: ctx.opened && ctx.trapFocus,
          innerRef: ref,
          children: /* @__PURE__ */jsx(Paper, _objectSpread(_objectSpread({}, others), {}, {
            component: "section",
            role: "dialog",
            tabIndex: -1,
            "aria-modal": true,
            "aria-describedby": ctx.bodyMounted ? ctx.getBodyId() : void 0,
            "aria-labelledby": ctx.titleMounted ? ctx.getTitleId() : void 0,
            style: [style, transitionStyles],
            className: cx(_defineProperty({}, classes.content, !ctx.unstyled), className),
            unstyled: ctx.unstyled,
            children: others.children
          }))
        })
      }));
    }
  }));
});
export { ModalBaseContent };